import PropTypes from 'prop-types';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import {GRID_SCHEMA_CLASSES, GRID_SCHEMA_CLASS_TO_TYPE_TEXT} from 'constants/SampleConstants';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as SampleSchemaActions from 'samples/SampleSchemaActions';
import SampleSchemaStore from 'samples/SampleSchemaStore';
import {GRID_SCHEMA_SHAPE} from 'samples/storables/StorableSchemaConstants';
import GridSchemasListing from 'settings/samples/GridSchemasListing';
import {setWindowTitle} from 'BenchlingUtil';

class GridSchemasPageConnector extends DataConnector {
  shouldSubscribeToRedux = false;
  stores = [SampleSchemaStore];

  enhanceProps() {
    return {
      gridSchemas: this.sampleSchemaStore().getGridSchemas(
        this.props.registryId,
        this.props.gridSchemaClass,
        {
          includeArchived: true,
        }
      ),
    };
  }
}

export class GridSchemasPage extends React.Component {
  static propTypes = {
    gridSchemaClass: PropTypes.oneOf(GRID_SCHEMA_CLASSES).isRequired,
    ownerUrlId: PropTypes.string.isRequired,
    registryId: PropTypes.string.isRequired,

    // Props provided by connect
    isWritable: PropTypes.bool.isRequired,
    gridSchemas: PropTypes.arrayOf(GRID_SCHEMA_SHAPE),
  };

  componentDidMount() {
    SampleSchemaActions.fetchAllGridSchemas(this.props.gridSchemaClass);
  }

  render() {
    setWindowTitle(
      `${GRID_SCHEMA_CLASS_TO_TYPE_TEXT[this.props.gridSchemaClass]} Schemas - Registry Settings`
    );

    return (
      <GridSchemasListing
        gridSchemaClass={this.props.gridSchemaClass}
        gridSchemas={this.props.gridSchemas}
        isWritable={this.props.isWritable}
        ownerUrlId={this.props.ownerUrlId}
        registryId={this.props.registryId}
      />
    );
  }
}

function QueryingGridSchemasPage(props) {
  // eslint-disable-next-line react/prop-types
  const isWritable = RegistryUtil.useIsRegistryWritableQuery(props.registryId);
  return <GridSchemasPage {...props} isWritable={isWritable} />;
}

export default GridSchemasPageConnector.connect(QueryingGridSchemasPage);
